module.exports = __webpack_public_path__ + "img/main.2657f509.jpg";